import React from "react";
import { LoadPanel } from "devextreme-react/load-panel";

const Spinner = () => {
  return (
    <LoadPanel
      visible={true}
      showIndicator={true}
      closeOnOutsideClick={false}
    />
  );
};

export default Spinner;
